import { render, staticRenderFns } from "./dialog-preview-public.vue?vue&type=template&id=f2545222&scoped=true&"
import script from "./dialog-preview-public.vue?vue&type=script&lang=js&"
export * from "./dialog-preview-public.vue?vue&type=script&lang=js&"
import style0 from "./dialog-preview-public.vue?vue&type=style&index=0&id=f2545222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2545222",
  null
  
)

export default component.exports